<div
        class="flex justify-start items-center w-full"
>
    <div
            class="flex items-center space-x-4  p-2 rounded-md"
    >
        <ng-container *ngFor="let state of searchInputStates; let index = index">
            <ng-container *ngTemplateOutlet="stateTpl; context: { state, index }"></ng-container>
        </ng-container>
        <action-buttons
                *ngIf="getUnusedKey() && !getUnfilledState()"
                [actionButtons]="[addbutton]"
                class="absolute top-1 "
        ></action-buttons>
    </div>
</div>

<ng-template #stateTpl let-index="index" let-state="state">
    <!-- Parent Container -->
    <div
            [style.--order]="order"
            class="flex items-center border border-gray-300 dark:border-gray-700 rounded-md bg-white
      dark:bg-gray-800 dark:text-gray-300 {{animation}} p-2 space-x-4"
    >
        <!-- Search Input -->
        <mat-form-field
                appearance="outline"
                class="p-2 search-form-field bg-transparent dark:bg-gray-700 text-gray-500 w-full"
        >
            <mat-icon class="text-gray-500" matPrefix fontIcon="search"></mat-icon>
            <mat-icon
                    (click)="state.value = ''; searchInputChange.emit(searchInputStates)"
                    *ngIf="input.value"
                    class="text-red-500 cursor-pointer"
                    matSuffix
            >
                close
            </mat-icon>
            <input
                #input
                (keyup)="onKeyUp(state)"
                [(ngModel)]="state.value"
                [placeholder]="'Search'"
                autocomplete="off"
                matInput
                class="bg-transparent dark:bg-gray-700 text-gray-500"
            />
        </mat-form-field>

        <!-- Divider -->
        <span *ngIf="searchKeys?.length" class="text-gray-500 px-2"> | </span>

        <!-- Dropdown -->
        <mat-form-field
                *ngIf="searchKeys?.length"
                [matTooltip]="'Search by ' + (state?.key | camelToTitleCase | readDotProperty)"
                appearance="outline"
                class="p-2 bg-transparent dark:bg-gray-700 text-gray-500 w-full"
        >
            <mat-icon class="text-gray-400" matSuffix svgIcon="edit"></mat-icon>
            <mat-select (selectionChange)="onSelectionChange(state)"
                        [(ngModel)]="state.key"
                        class="bg-transparent dark:bg-gray-700 text-gray-500"
            >
                <mat-option *ngFor="let key of (unUsedKeys | push : state.key)"
                            [value]="key"
                            class="bg-gray-700 text-gray-500"
                >
                    {{ key | camelToTitleCase | readDotProperty }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</ng-template>